import { Component, Host, h, Prop } from '@stencil/core';

/**
 * @slot - Designed to receive col's content.
 */
@Component({
  tag: 'sy-col',
  styleUrls: ['scss/index.scss', 'scss/_tokens.scss'],
  shadow: true,
})
export class Col {
  /**
   * Defines how many of the 12 available columns of the row will be occupied in all screens. Must be a value between 1 and 12, both included. If set to `auto`,
   * it will use the remaining space available.
   */
  @Prop({ reflect: true }) size: number | 'auto';

  /**
   * Defines how many of the 12 available columns of the row will be occupied in small screens. Must be a value between 1 and 12, both included. If set to `auto`,
   * it will use the remaining space available.
   */
  @Prop({ reflect: true }) sizeSm: number | 'auto';

  /**
   * Defines how many of the 12 available columns of the row will be occupied in medium screens. Must be a value between 1 and 12, both included. If set to `auto`,
   * it will use the remaining space available.
   */
  @Prop({ reflect: true }) sizeMd: number | 'auto';

  /**
   * Defines how many of the 12 available columns of the row will be occupied in large screens. Must be a value between 1 and 12, both included. If set to `auto`,
   * it will use the remaining space available.
   */
  @Prop({ reflect: true }) sizeLg: number | 'auto';

  /**
   * Defines how many of the 12 available columns of the row will be occupied in extra large screens. Must be a value between 1 and 12, both included. If set to `auto`,
   * it will use the remaining space available.
   */
  @Prop({ reflect: true }) sizeXl: number | 'auto';

  /**
   * Defines how many of the 12 available columns of the row will be occupied in extra extra large screens. Must be a value between 1 and 12, both included. If set to `auto`,
   * it will use the remaining space available.
   */
  @Prop({ reflect: true }) sizeXxl: number | 'auto';

  /**
   * Defines how many columns the element will shift to the end in all screens. Must be a value between 1 and 12, both included.
   */
  @Prop({ reflect: true }) offset: number;

  /**
   * Defines how many columns the element will shift to the end in small screens. Must be a value between 1 and 12, both included.
   */
  @Prop({ reflect: true }) offsetSm: number;

  /**
   * Defines how many columns the element will shift to the end in medium screens. Must be a value between 1 and 12, both included.
   */
  @Prop({ reflect: true }) offsetMd: number;

  /**
   * Defines how many columns the element will shift to the end in large screens. Must be a value between 1 and 12, both included.
   */
  @Prop({ reflect: true }) offsetLg: number;

  /**
   * Defines how many columns the element will shift to the end in extra large screens. Must be a value between 1 and 12, both included.
   */
  @Prop({ reflect: true }) offsetXl: number;

  /**
   * Defines how many columns the element will shift to the end in extra extra large screens. Must be a value between 1 and 12, both included.
   */
  @Prop({ reflect: true }) offsetXxl: number;

  /**
   * Defines the order of the column in all screens. Must be a value between 1 and 12, both included.
   */
  @Prop({ reflect: true }) order: number;

  /**
   * Defines the order of the column in small screens. Must be a value between 1 and 12, both included.
   */
  @Prop({ reflect: true }) orderSm: number;

  /**
   * Defines the order of the column in medium screens. Must be a value between 1 and 12, both included.
   */
  @Prop({ reflect: true }) orderMd: number;

  /**
   * Defines the order of the column in large screens. Must be a value between 1 and 12, both included.
   */
  @Prop({ reflect: true }) orderLg: number;

  /**
   * Defines the order of the column in extra large screens. Must be a value between 1 and 12, both included.
   */
  @Prop({ reflect: true }) orderXl: number;

  /**
   * Defines the order of the column in extra extra large screens. Must be a value between 1 and 12, both included.
   */
  @Prop({ reflect: true }) orderXxl: number;

  render() {
    return (
      <Host>
        <slot></slot>
      </Host>
    );
  }
}
